import styled from "styled-components";

export const Container = styled.div`
    width: 350px;
    display: flex;
    flex-direction: column;
`;

